import { HttpInterceptorFn, HttpXsrfTokenExtractor } from '@angular/common/http';

import { Inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class XsrfInterceptor implements HttpXsrfTokenExtractor {
  private lastCookieString = '';
  private lastToken: string | null = null;

  constructor(@Inject(DOCUMENT) private doc: Document) {}

  getToken(): string | null {
    const cookieName = environment.csrfCookieName;
    if (!cookieName) return null;

    const cookieString = this.doc.cookie || '';
    if (cookieString !== this.lastCookieString) {
      this.lastCookieString = cookieString;
      this.lastToken = this.parse(cookieString, cookieName);
    }
    return this.lastToken;
  }

  private parse(cookieString: string, name: string): string | null {
    const escaped = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
    const match = cookieString.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }
}